exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.terms-container a[data-v-4dc211a9] {\n  text-decoration: underline;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/common/BaseTermsBlurb.vue"],"names":[],"mappings":";AAAA;EACE,2BAA2B;CAAE","file":"BaseTermsBlurb.vue","sourcesContent":[".terms-container a {\n  text-decoration: underline; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dc211a9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseTermsBlurb.vue
// module id = 6lI5
// module chunks = 18